import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import DropdownApi from '../../components/DropdownApi';
import { UserSession } from '../../models/UserSession';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import { NprLookup } from '../../service/api-service';
import S3ImagePreview from '../../components/S3ImagePreview';
import { Avatar } from 'primereact/avatar';
import { placeholder } from '../../assets/placeholder';
import MultiDropdownApi from '../../components/MultiDropdownApi';
import ImageS3Upload from '../../components/ImageS3Upload';
import { v4 as uuid } from 'uuid';
import { addEquipment, updateEquipment } from '../../service/equipmentService';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Grid } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import IntervalDropdown from '../../components/IntervalDropdown';
import { add, update } from '../../service/equipmentListService';
import { addAttendance, updateAttendance } from '../../service/attendanceService';
import { AlternateEmailOutlined } from '@mui/icons-material';
import SignatureCanvas from "react-signature-canvas";

export default function AttendanceAdd(modalProps: any) {

  const record = modalProps?.record;
  const client_id = modalProps?.client_id;
  const site_id = modalProps?.site_id;

  async function Add() {

    let updateDetails: any = {
      client_id: client_id,
      site_id: siteId,
      full_name: fullName,
      mobile: mobile,
      email: email,
      id_number: idNumber,
      type: type,
      reason_for_visit: reasonForVisit,
      signature: signature,
      start_at: startAt
    };
    if (type == 'Employee' && !!employeeId) {
      updateDetails.employee_id = employeeId;
    }
    if (endAt != '') {
      updateDetails.end_at = endAt;
    }
    modalProps.setGlobalLoading(true);
    if (record?.id) {
      updateAttendance(updateDetails, record.id).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Attendance Updated Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      }).catch((error) => {
        modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Updated Attendance', life: 3000 });
        modalProps.setGlobalLoading(false);
      })
    } else {
      const dataUrl = signatureRef.current.toDataURL();
      if (dataUrl) {
        updateDetails.signature = dataUrl;
      }
      addAttendance(updateDetails).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Attendance Created Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      }).catch((error) => {
        modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Create Attendance', life: 3000 });
        modalProps.setGlobalLoading(false);
      })
    }
  }


  const [siteId, setSiteId] = React.useState(record?.site_id || site_id || "");
  const [employeeId, setEmployeeId] = React.useState(record?.employee_id || "");
  const [fullName, setFullName] = React.useState(record?.full_name || "");
  const [mobile, setMobile] = React.useState(record?.mobile || "");
  const [email, setEmail] = React.useState(record?.email || "");
  const [type, setType] = React.useState(record?.type || "Visitor");
  const [reasonForVisit, setReasonForVisit] = React.useState(record?.reason_for_visit || "");
  const [startAt, setStartAt] = React.useState<any>(record?.start_at ? new Date(record?.start_at) : new Date());
  const [endAt, setEndAt] = React.useState<any>(record?.end_at ? new Date(record?.end_at) : '');
  const [signature, setSignature] = React.useState(record?.signature || "");
  const [idNumber, setIdNumber] = React.useState(record?.id_number || "");

  const signatureRef = React.useRef<any>();

  // Function to clear the signature
  const clearSignature = () => {
    signatureRef.current.clear();
    setSignature('');
  };


  const [employeeObject, setEmployeeObject] = React.useState<any>({});

  const types = [
    { name: 'Visitor' },
    { name: 'Sub Contractor' },
    { name: 'Employee' }
  ];

  React.useEffect(() => {
    setFullName(employeeObject?.full_name);
    setMobile(employeeObject?.mobile);
    setEmail(employeeObject?.email);
    setIdNumber(employeeObject?.id_number);
  }, [employeeId])

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        {
          !site_id ?
            <Grid item xs={12}>
              <DropdownApi apiPath='site-list' optionLabel="name" optionValue='id' label='Site' selectedData={siteId} setSelectedData={setSiteId} />
            </Grid> : ''
        }
        <Grid item xs={12}>
          <FormControl
            sx={{ display: { sm: 'flex-column', md: 'flex-row' } }}
          >
            <FormLabel style={{ marginBottom: 10 }}>Type</FormLabel>
            <Dropdown value={type} onChange={(e) => setType(e.value)} options={types} optionLabel="name" optionValue='name'
              placeholder="Select a Type" className="PrimeSmallInput custom-dropdown" panelClassName="custom-dropdown-panel" />
          </FormControl>
        </Grid>
        {
          type === 'Employee' ?
            <Grid item xs={12}>
              <DropdownApi apiPath='site-employee' queryParams={{ siteId }} optionLabel="full_name" optionValue='id' label='Employee' selectedData={employeeId} setSelectedData={setEmployeeId} setSelectedObject={setEmployeeObject} />
            </Grid>
            : ''
        }
        <Grid item xs={6}>
          <FormControl
            sx={{ display: { sm: 'flex-column', md: 'flex-row' } }}
          >
            <FormLabel style={{ marginBottom: 10 }}>Full Name</FormLabel>
            <InputText value={fullName} onChange={(e) => setFullName(e.target.value)} disabled={type == 'Employee'} type="text" className="p-inputtext-sm PrimeSmallInput" placeholder="Please enter name" />
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <FormControl
            sx={{ display: { sm: 'flex-column', md: 'flex-row' } }}
          >
            <FormLabel style={{ marginBottom: 10 }}>ID Number</FormLabel>
            <InputText value={idNumber} onChange={(e) => setIdNumber(e.target.value)} disabled={type == 'Employee'} type="text" className="p-inputtext-sm PrimeSmallInput" placeholder="Please enter ID number" />
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <FormControl
            sx={{ display: { sm: 'flex-column', md: 'flex-row' } }}
          >
            <FormLabel style={{ marginBottom: 10 }}>Mobile</FormLabel>
            <PhoneInput
              defaultCountry="za"
              value={mobile}
              disabled={type == 'Employee'}
              onChange={e => setMobile(e)}
              inputStyle={{ width: '100%' }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl
            sx={{ display: { sm: 'flex-column', md: 'flex-row' } }}
          >
            <FormLabel style={{ marginBottom: 10 }}>Email</FormLabel>
            <div className="p-inputgroup ">
              <span className="p-inputgroup-addon PrimeSmallInput">
                <AlternateEmailOutlined />
              </span>
              <InputText style={{ width: '100%' }} disabled={type == 'Employee'} value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="p-inputtext-sm PrimeSmallInput" placeholder="Please email" />
            </div>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Start At</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Calendar value={startAt} onChange={(e) => setStartAt(e.value)} showIcon showTime />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl>
            <FormLabel>End At</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Calendar value={endAt} onChange={(e) => setEndAt(e.value)} showIcon showTime minDate={startAt} />
            </FormControl>
          </FormControl>
        </Grid>
        <br />
        {
          type !== 'Employee' && (
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Reason For Visit</FormLabel>
                <FormControl
                  sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
                >
                  <InputText value={reasonForVisit} placeholder="Reason For Visit" onChange={e => setReasonForVisit(e.target.value)} />
                </FormControl>
              </FormControl>
            </Grid>
          )
        }
        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Signature</FormLabel>
            {signature != '' ? (
              <div>
                <img src={signature} alt="signature" />
              </div>
            ) : <SignatureCanvas
              ref={signatureRef}
            />}
          </FormControl>
        </Grid>
      </Grid>
      <br /><br />
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => Add()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}